import { type ReactNode } from 'react';
import { Column, type SpacingScale } from '@tempmee/react';
import styles from './FixedWidthScreen.module.css';

export interface IFixedWidthScreenProps {
  children: ReactNode;
  /** Vertical gap between children, on the DS spacing scale. @default 6 */
  gap?: SpacingScale;
  /** Extra classes merged onto the inner pane surface. */
  className?: string;
  /** Test hook forwarded to the inner pane. */
  'data-cy'?: string;
}

/**
 * Page-level layout: a subdued full-bleed backdrop with a centered white pane
 * on top, capped at 536px and padded 24px. Use it for narrow, reading-width
 * screens (application forms, single-column summaries) that should read as a
 * raised surface floating on the dashboard chrome — the same role the
 * deprecated DS `Screen` filled, composed from DS primitives instead.
 */
export const FixedWidthScreen = ({
  children,
  gap = 6,
  className,
  ...rest
}: IFixedWidthScreenProps) => (
  <Column className={`${styles.page} bg-background-subdued`} flex p={6}>
    <Column
      className={className ? `${styles.pane} ${className}` : styles.pane}
      p={6}
      gap={gap}
      {...rest}
    >
      {children}
    </Column>
  </Column>
);
